import React, { useMemo, useRef } from 'react'
import PropTypes from 'prop-types'

import Tooltip from '../Tooltip'

import './SurveyLink.scss'

const CLASS = 'insights-portal-survey-link'

const SurveyLink = props => {
  const className = props.className || CLASS

  const value = useMemo(
    () => (!props.value ? null : Array.isArray(props.value) ? props.value : [props.value]),
    [props.value]
  )

  const refs = useRef([])

  const links = value
    ? value.map((v, i) =>
        v && v.id ? (
          <a
            key={i}
            ref={element => (refs.current[i] = element)}
            className={`${className}-item ${props.showNames ? '' : ` ${className}-item-id`}`}
            href={`/surveys/${v.id}/stat`}
            rel="noreferrer"
            target="_blank"
          >
            {props.showNames ? (Array.isArray(v.name) && v.name.length ? v.name.join(' ') : v.name || v.id) : v.id}
            {v.name && !props.disabled && !props.showNames ? (
              <Tooltip
                onTarget={() => refs.current[i]}
                position={'up-right'}
                content={<div className={`${className}-tooltip`}>{v.name}</div>}
                showOn={'mouseenter'}
                hideOn={'click click:body wheel:body scroll:body mouseleave'}
              />
            ) : null}
          </a>
        ) : props.disabled ? (
          <div key={i} className={`${className}-item-disabled`}>
            {v}
          </div>
        ) : (
          <a key={i} className={`${className}-item`} href={`/surveys/${v}/stat`} rel="noreferrer" target="_blank">
            {v}
          </a>
        )
      )
    : null

  const content =
    links?.length > 1
      ? links.reduce((acc, cur, idx) => {
          if (0 === idx) acc.push('[')
          acc.push(cur)
          if (links.length - 1 === idx) acc.push(']')
          else acc.push([','])
          return acc
        }, [])
      : links

  return <div className={className}>{content}</div>
}

SurveyLink.propTypes = {
  className: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.any,
  showNames: PropTypes.bool
}

export default SurveyLink
